// 获取元素相对页面的绝对位置
const getElementLeft = element => {
  var actualLeft = element.offsetLeft
  var current = element.offsetParent
  while (current !== null) {
    actualLeft += current.offsetLeft + current.clientLeft
    current = current.offsetParent
  }
  return actualLeft
}
const getElementTop = element => {
  var actualTop = element.offsetTop
  var current = element.offsetParent
  while (current !== null) {
    actualTop += current.offsetTop + current.clientTop
    current = current.offsetParent
  }
  return actualTop
}

const getScrollTop = () => {
  return Math.floor(
    document.body.scrollTop ||
      document.documentElement.scrollTop ||
      window.pageYOffset
  )
}

const getScrollLeft = () => {
  return Math.floor(
    document.body.scrollLeft ||
      document.documentElement.scrollLeft ||
      window.pageXOffset
  )
}

const guid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()
}

const isObject = obj => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
const isArray = obj => {
  return Object.prototype.toString.call(obj) === '[object Array]'
}
const isString = obj => {
  return Object.prototype.toString.call(obj) === '[object String]'
}
const isNumber = obj => {
  return Object.prototype.toString.call(obj) === '[object Number]'
}

// 防抖
function debounce(fn, delay) {
  var timer // 维护一个 timer
  return function() {
    var _this = this // 取debounce执行作用域的this
    var args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      fn.apply(_this, args) // 用apply指向调用debounce的对象，相当于_this.fn(args);
    }, delay)
  }
}

//手动触发窗口resize事件
function doResize() {
  setTimeout(function() {
    if (document.createEvent) {
      var event = document.createEvent('HTMLEvents')
      event.initEvent('resize', true, true)
      window.dispatchEvent(event)
    } else if (document.createEventObject) {
      window.fireEvent('onresize')
    }
  }, 0)
}

// 复制到粘贴板
function copyToBlock(val) {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', val)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
  }
  document.body.removeChild(input)
}

// 无闪现下载
function download(url, filename, domain, callback) {
  var x = new XMLHttpRequest()
  const URL = domain ? `${domain}/${url}` : url
  x.open('GET', URL, true)
  x.responseType = 'blob'
  x.onload = () => {
    var url = window.URL.createObjectURL(x.response)
    var a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    if (callback) {
      callback()
    }
  }
  x.send()
}

export {
  getElementLeft,
  getElementTop,
  getScrollTop,
  getScrollLeft,
  guid,
  isObject,
  isArray,
  isString,
  isNumber,
  debounce,
  doResize,
  copyToBlock,
  download
}
